import {io} from 'socket.io-client'
import {envVars} from './envVars'

const URL = envVars.VITE_WS_ENDPOINT
export const socket = io(URL, {
    reconnectionDelay: 2000,
    reconnectionAttempts: 1,
    transports: ['websocket']
})